import { render, staticRenderFns } from "./IntroductionPOSSystem.vue?vue&type=template&id=3d32e92d&scoped=true&"
import script from "./IntroductionPOSSystem.vue?vue&type=script&lang=ts&"
export * from "./IntroductionPOSSystem.vue?vue&type=script&lang=ts&"
import style0 from "./IntroductionPOSSystem.vue?vue&type=style&index=0&id=3d32e92d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d32e92d",
  null
  
)

export default component.exports